// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const IconLightBulbSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      viewBox="0 0 59 58"
      xmlns="http://www.w3.org/2000/svg"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path d="M32.765 45.131h-5.776a1.738 1.738 0 01-1.736-1.734v-3.448a8.507 8.507 0 00-1.906-4.295 12.315 12.315 0 01-2.655-7.147c0-5.706 3.948-10.007 9.184-10.007 5.235 0 9.183 4.301 9.183 10.005a12.303 12.303 0 01-2.654 7.15A8.533 8.533 0 0034.5 39.95v3.448a1.734 1.734 0 01-1.735 1.733v.001zm-2.89-24.818a7.65 7.65 0 00-6.977 5.162 7.638 7.638 0 00-.392 3.03c.11 2.222.918 4.353 2.31 6.088a10.575 10.575 0 012.249 5.356v3.448l5.7-.08-.08-3.368a10.307 10.307 0 012.249-5.356 10.557 10.557 0 002.312-6.086 7.635 7.635 0 00-4.396-7.484 7.65 7.65 0 00-2.974-.71z" />
      <path d="M26.497 39.657h6.621v1.813h-6.62v-1.813zm2.47-25.215h1.814v2.481h-1.814v-2.481zm9.713 7.783l2.213-1.126.821 1.613-2.212 1.126-.822-1.613zm-20.628.359l.823-1.613 2.213 1.127-.824 1.613-2.212-1.127zm.105 11.542L20.369 33l.822 1.613-2.212 1.124-.822-1.611z" />
      <path d="M38.747 22.174l2.213-1.125.821 1.613-2.212 1.125-.822-1.613zm-20.657 12l2.212-1.125.822 1.613-2.213 1.126-.821-1.613zm20.581.412l.824-1.613 2.212 1.127-.823 1.614-2.213-1.128z" />
    </svg>
  )
}
